import { useState, useEffect } from 'react';

/**
 * @returns true if content in the containerRef overflows
 *  based on the container styles defined in calling component
 */
function useOverflow(_a) {
    var containerRef = _a.containerRef, _b = _a.defaultValue, defaultValue = _b === void 0 ? false : _b;
    var _c = useState(defaultValue), isOverflow = _c[0], setIsOverflow = _c[1];
    useEffect(function () {
        if (containerRef.current) {
            var _a = containerRef.current, offsetHeight = _a.offsetHeight, scrollHeight = _a.scrollHeight;
            if (offsetHeight < scrollHeight) {
                setIsOverflow(true);
            }
        }
    }, [containerRef.current]);
    return isOverflow;
}

export { useOverflow };
//# sourceMappingURL=useOverflow.js.map
